import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosInstance";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "../Spinner";
import Badge from "@mui/material/Badge";
import "react-toastify/dist/ReactToastify.css";
import ActionButtons from "./DriversListActionButton.js";


import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { 
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';


const DriversList = () => {
  let [loading, setLoading] = useState(true);
  const [drivers, setDrivers] = useState([]);

  const navigate = useNavigate();

  
  const getDrivers = async () => {
    await axiosInstance
      .get("/ActiveDrivers")
      .then((res) => {
        setDrivers(res.data);
        setLoading(false);
        notify();
      })
      .catch((err) => {
        setLoading(false);
        notifyError();
      });
  };

  const notify = () =>
    toast.success("Drivers list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  useEffect(() => {
    getDrivers();
  }, []);
  const columns = React.useMemo(
  () => [
    {
      Header: "Name",
      columns: [
        {
          Header: "ID",
          accessor: "id",
        },
        {
          Header: "First Name",
          accessor: "driver2.firstName",
        },
        {
          Header: "Last Name",
          accessor: "driver2.lastName",
        },
        {
          Header: "Phone Number",
          accessor: "driver2.phoneNumber",
        },
        {
          Header: "Ambulance Company",
          accessor: "driver2.driverAmbulanceCompany.company_name",
          Cell: ({ value }) => value ? value : <span style={{ color: 'gray' }}>N/A</span>,
        },
      ],
    },
    {
      Header: "Activity Info",
      columns: [
        {
          Header: "Location Latitude",
          accessor: "locationLatitude",
        },
        {
          Header: "Location Longitude",
          accessor: "locationLongitude",
        },
        {
          Header: "Queue Number",
          accessor: "queueNumber",
        },
        {
          Header: "Plate Number",
          accessor: "vehicle.plateNumber",
          Cell: ({ value }) => value ? value : <span style={{ color: 'gray' }}>N/A</span>,
        },
        {
          Header: "Vehicle Type",
          accessor: "typeName",
          Cell: ({ value }) => value ? value : <span style={{ color: 'gray' }}>N/A</span>,
        },
        {
          Header: "Status",
          accessor: "status",
          disableFilters: true,
          Cell: (row) => {
            const status = row.cell.row.original.status || "Ready";
            return (
              <Chip 
                label={status} 
                color={status === "Ready" ? "success" : "error"}
                variant="filled"
                sx={{
                  fontWeight: 'bold',
                  borderRadius: '8px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: status === "Ready" 
                    ? '0 2px 4px rgba(0,255,0,0.2)' 
                    : '0 2px 4px rgba(255,0,0,0.2)'
                }}
              />
            );
          },
        },
      ],
    },
  ],
  []
);

  return (
    <div 
    // style={{marginTop: "40px"}}
     className="content-wrappers">
      <ToastContainer />

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
               
              
                <ActionButtons
                is_all_drivers={false}

                />

                <div className="card-body">
                  <div className="card-body">
                    {loading && (
                      <div>
                        <Spinner />
                      </div>
                    )}
                    {!loading && <Table columns={columns} data={drivers} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DriversList;
